import {Injectable, Injector} from "@angular/core";
import {BaseService} from "@shared/services/base.service";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {catchError, map} from "@node_modules/rxjs/operators";
import { FileDto } from "@shared/service-proxies/service-proxies";

@Injectable()
export class ImportService extends BaseService {

    constructor(
        private readonly _httpClient: HttpClient, protected readonly injector: Injector) {
        super(injector);
    }

    /**
     * Downloads a template as an excel file
     * @param id Template Id
     */
    downloadTemplateFile(id: number): Observable<FileDto> {
        let url = this.environment.backendUrl + '/import/GetImportTemplateSampleFile';
        url = url.replace(/[?&]$/, "");

        let params = new HttpParams();

        params = params.appendAll({
            "templateId": id
        });

        let headers = new HttpHeaders({
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        return this._httpClient
            .get<any>(url, {params: params, headers: headers})
            .pipe(
                map((response: any) => {
                    return response.result as FileDto ?? null;
                }),
                catchError(this.handleError),
            );
    }

}
